<template>
    <div>
        <p>
            <b>{{ 'shopcart.total' | trans }}:</b>
        </p>
        <h4>{{ total | num_format }} &euro;</h4>
        <p>{{ 'shopcart.price_notice' | trans }}</p>
    </div>
</template>

<script>
    export default {
        props: {
            total: {
                type: Number,
                required: true
            }
        }
    };
</script>



// WEBPACK FOOTER //
// src/components/ArticlesPrice.vue